import { useDispatch, useSelector } from "react-redux";
import WebLayout from "../../../layout/WebLayout";
import {
  LOGO,
  PHONE,
  GMAIL,
  WEBSITE,
  CARDLOGO,
} from "../../../utils/Constants";
import { RootState } from "../../../stores";
import { useCallback, useEffect } from "react";
import profileAction from "../../../stores/actions/profileAction";

function ErmCard() {
  const dispatch = useDispatch<any>();
  const { ermData } = useSelector((state: RootState) => state.profile);
  const getErmDetails = useCallback(async () => {
    await dispatch(profileAction.getErmData());
  }, []);

  useEffect(() => {
    getErmDetails();
  }, [getErmDetails]);

  return (
    <WebLayout pageName={"ErmCard"}>
      <div className="content-wrapper">
        <div className="container-fluid flex-grow-1 container-p-y">
          <div className="row">
            <div className="col-lg-12">
              <div className="card vh-100">
                {/* <div className="card-header p-2">
                         <h4 className="card-title" style="font-size: 18px !important;">Download Card</h4>
                    </div> */}
                <div className="card-body">
                  <div className="ds-body" id="printableArea">
                    <div className="ds-card">
                      <div className="gre"></div>
                      <div className="text-center">
                        {/* <img className="ds-abhh-logo" src={CARDLOGO} alt="logo" /> */}

                        <h3 className="ds-sub-title">AMSME TRADING CARD</h3>
                      </div>
                      <div className="ds-dflex">
                        <div className="ds-left">
                          <img src={LOGO} alt="logo" width="100%" />
                        </div>
                        <div className="ds-right ds-text-center">
                          <div className="ds-dflex-1">
                            <div className="ds-text-left">
                              <div className="">
                                <span className="ds-d-block">ERM No: </span>
                                <span className="ds-d-block">Name: </span>
                                <span className="ds-d-block">Mobile: </span>
                                <span className="ds-d-block">State: </span>
                                <span className="ds-d-block">
                                  Guide ERM No:{" "}
                                </span>
                              </div>
                              <div className="">
                                <input
                                  className="ds-border-bottom"
                                  type="text"
                                  placeholder=""
                                  aria-label=""
                                  value={ermData?.referral_code}
                                />
                                <input
                                  className="ds-border-bottom"
                                  type="text"
                                  placeholder=""
                                  aria-label=""
                                  value={ermData?.name_of_entity}
                                />
                                <input
                                  className="ds-border-bottom"
                                  type="text"
                                  placeholder=""
                                  aria-label=""
                                  value={ermData?.mobile}
                                />
                                <input
                                  className="ds-border-bottom"
                                  type="text"
                                  placeholder=""
                                  aria-label=""
                                  value={
                                    ermData.state != null
                                      ? ermData.state
                                      : "N/A"
                                  }
                                />
                                <input
                                  className="ds-border-bottom"
                                  type="text"
                                  placeholder=""
                                  aria-label=""
                                  value={ermData?.referral_by}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="footer-bg">
                        <h2 className="ds-title">
                          ABHHYAM MARKETING INDIA PRIVATE LIMITED
                        </h2>
                        <ul>
                          <li>
                            <img src={PHONE} width="20px" /> 9990060531
                          </li>
                          <li>
                            <img src={WEBSITE} width="20px" />{" "}
                            www.amsmetrading.com
                          </li>
                          <li>
                            <img src={GMAIL} width="20px" />{" "}
                            amsmetrading@gmail.com
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default ErmCard;
